import {createElement,useState,useEffect} from "react";
import {useAppI18n} from "../../lib/appI18n";
export const osMessages = {
  "en": {
    "overview": "Overview",
    "people": "People",
    "access": "Access",
    "protection": "Protection",
    "events": "History",
    "settings": "Settings",
    "providers": "Providers",
    "models": "Models",
    "routing": "Routing",
    "more": "More",
    "close": "Close",
    "back": "Back",
    "inspect": "Inspect",
    "openDetail": "Open detail",
    "openDetailHelp": "Open the full person record with contact, addresses, access and activity.",
    "refresh": "Refresh",
    "searchPeople": "Find a person",
    "all": "Everyone",
    "needsReview": "Needs review",
    "user": "Current user",
    "language": "Language",
    "actions": "Actions",
    "help": "How this works",
    "technical": "Technical details",
    "evidence": "Raw evidence",
    "status": "Status",
    "why": "Why",
    "impact": "What this affects",
    "verify": "Verification",
    "role": "Organization role",
    "effective": "Effective access",
    "static": "Static access",
    "passkeys": "Active passkeys",
    "unlock": "Unlock-capable passkeys",
    "trust": "Trust groups",
    "keyReady": "Key setup ready",
    "keyPending": "Key setup incomplete",
    "keyWhy": "The security record reports a ready wrapping key.",
    "keyWhyMissing": "The security record does not report a ready wrapping key.",
    "keyImpact": "This describes key setup only. Workspace sign-in and permissions are evaluated separately.",
    "peopleHelp": "Find a person, inspect their access and open the details where you are.",
    "emptyPeople": "No people in this view",
    "emptyHelp": "Change your search or refresh the current records.",
    "unknown": "Not verified",
    "stale": "The latest refresh failed. Shown records may be out of date.",
    "loading": "Loading current records…",
    "securityHelp": "Review what needs attention and take the next step here.",
    "controls": "Security checks",
    "summary": "Current summary",
    "noKnownIssues": "No issue reported in these checks",
    "unknownHealth": "The security assessment is not available.",
    "score": "Reported security score",
    "reviewHere": "Review here",
    "register": "Review registrations",
    "registerHelp": "Review pending registrations and complete their existing access setup.",
    "providerHelp": "Understand which services are available and resolve their conditions in place.",
    "readinessUnknown": "Routing readiness is not verified",
    "readinessUnknownHelp": "A current list alone does not prove that a task can be routed. Inspect the routing policy.",
    "ready": "Ready",
    "partial": "Partly ready",
    "blocked": "Action needed",
    "noModels": "No models reported",
    "modelHelp": "Open a model to inspect its status, routing conditions and available actions.",
    "routingCheck": "Routing conditions",
    "routingUnknown": "Inspect task-specific eligibility",
    "capability": "Latest capability check",
    "latency": "Response time",
    "issue": "Current issue",
    "facts": "Recorded details",
    "priority": "Needs your attention",
    "observed": "Last observation",
    "connection": "Connection",
    "infrastructure": "Service readiness",
    "context": "Current workspace",
    "navigation": "Workspace navigation",
    "skip": "Skip to workspace",
    "snapshot": "Snapshot evidence",
    "returnList": "Back to people",
    "keepOpen": "Close when your changes are complete.",
    "historyHelp": "Events retain their original timestamps and recorded outcomes.",
    "health": "Health",
    "availableActions": "Available actions",
    "noAutoClaim": "Final selection also depends on the actual request and its permissions.",
    "checks": "Checks",
    "owner": "Protected owner",
    "minimize": "Collapse details",
    "providerNotLoaded": "Provider data could not be verified.",
    "providerContext": "The connection change remains subject to the existing passkey and verification checks.",
    "editHere": "Change here",
    "accessOpen": "Allowed",
    "accessClosed": "Denied",
    "accessConditional": "Conditional",
    "permissionChange": "Change this permission",
    "permissionHelp": "This request changes the person’s direct policy. Other rules may still limit access; the result is refreshed after verification.",
    "allowHere": "Allow access",
    "denyHere": "Block access",
    "changeReason": "Why are you making this change?",
    "confirmPasskey": "Verify with passkey and apply",
    "cancelChange": "Cancel",
    "roleHelp": "Roles group permissions. Review the person’s effective access after assigning a role.",
    "addRoleHere": "Assign a role here",
    "chooseRole": "Choose a role",
    "roleOperator": "Platform operations",
    "roleMember": "Member",
    "roleOwner": "Owner",
    "roleAdmin": "Administrator",
    "roleTeacher": "Teacher",
    "roleLearner": "Learner",
    "capConsole": "Use the AI assistant",
    "capLid": "Use the learning workspace",
    "permissionOther": "Application permission",
    "removeRoleHere": "Remove this role",
    "roleSource": "Assigned roles",
    "workingHere": "Verifying and updating…",
    "modelSettings": "Usage settings",
    "modelCheck": "Check this model",
    "modelFix": "Review and resolve",
    "modelNext": "What can I do?",
    "modelHealthyHelp": "The connection test succeeded. Review usage settings to see which tasks can use this model.",
    "modelIssueHelp": "This model needs attention. Open the issue to see the reason and available actions.",
    "modelStaleHelp": "The available information is not current. Refresh the list before testing or changing anything.",
    "modelPendingHelp": "Run a check to see whether this model responds. A successful test alone does not enable it for every task.",
    "providerConnect": "Connect",
    "providerConnectionHelp": "Use the saved connection settings. The connection will be verified before it is shown as available.",
    "providerMissingHelp": "No connection settings are saved for this service yet. Setup is required before it can be connected.",
    "providerAddTitle": "Connect another AI service",
    "providerAddHelp": "Adding a new service from this screen is not supported yet. You can manage the services already configured below.",
    "providerShowModels": "Show models here",
    "lightTheme": "Light theme",
    "darkTheme": "Dark theme"
  },
  "tr": {
    "overview": "Genel bakış",
    "people": "Kişiler",
    "access": "Erişim",
    "protection": "Koruma",
    "events": "Geçmiş",
    "settings": "Ayarlar",
    "providers": "Sağlayıcılar",
    "models": "Modeller",
    "routing": "Yönlendirme",
    "more": "Diğer",
    "close": "Kapat",
    "back": "Geri",
    "inspect": "İncele",
    "openDetail": "Detayı aç",
    "openDetailHelp": "İletişim, adres, erişim ve etkinlik bilgileriyle birlikte tam kişi kaydını aç.",
    "refresh": "Yenile",
    "searchPeople": "Kişi ara",
    "all": "Tüm kişiler",
    "needsReview": "İncelenmeli",
    "user": "Mevcut kullanıcı",
    "language": "Dil",
    "actions": "İşlemler",
    "help": "Nasıl çalışır?",
    "technical": "Teknik ayrıntılar",
    "evidence": "Ham kanıt",
    "status": "Durum",
    "why": "Neden",
    "impact": "Etkisi",
    "verify": "Doğrulama",
    "role": "Kuruluş rolü",
    "effective": "Etkin erişim",
    "static": "Kalıcı erişim",
    "passkeys": "Etkin passkey’ler",
    "unlock": "Kilit açabilen passkey’ler",
    "trust": "Güven grupları",
    "keyReady": "Anahtar kurulumu hazır",
    "keyPending": "Anahtar kurulumu eksik",
    "keyWhy": "Güvenlik kaydı, sarmalama anahtarının hazır olduğunu bildiriyor.",
    "keyWhyMissing": "Güvenlik kaydı, hazır bir sarmalama anahtarı bildirmiyor.",
    "keyImpact": "Bu durum yalnız anahtar kurulumunu gösterir. Çalışma alanına giriş ve izinler ayrıca değerlendirilir.",
    "peopleHelp": "Kişiyi bulun; erişimini ve ayrıntılarını aynı yerde inceleyin.",
    "emptyPeople": "Bu görünümde kişi yok",
    "emptyHelp": "Aramayı değiştirin veya kayıtları yenileyin.",
    "unknown": "Doğrulanmadı",
    "stale": "Son yenileme başarısız. Görünen kayıtlar güncel olmayabilir.",
    "loading": "Güncel kayıtlar yükleniyor…",
    "securityHelp": "İlgilenmeniz gereken durumu inceleyin; sonraki adımı burada tamamlayın.",
    "controls": "Güvenlik kontrolleri",
    "summary": "Güncel özet",
    "noKnownIssues": "Bu kontrollerde sorun bildirilmedi",
    "unknownHealth": "Güvenlik değerlendirmesi mevcut değil.",
    "score": "Bildirilen güvenlik puanı",
    "reviewHere": "Burada incele",
    "register": "Kayıtları incele",
    "registerHelp": "Bekleyen kayıtları inceleyin ve mevcut erişim kurulumlarını tamamlayın.",
    "providerHelp": "Hangi hizmetlerin kullanılabildiğini görün; koşullarını aynı yerde çözün.",
    "readinessUnknown": "Yönlendirme hazırlığı doğrulanmadı",
    "readinessUnknownHelp": "Listenin güncel olması, görevin yönlendirilebildiğini kanıtlamaz. Yönlendirme politikasını inceleyin.",
    "ready": "Hazır",
    "partial": "Kısmen hazır",
    "blocked": "İşlem gerekiyor",
    "noModels": "Model bildirilmedi",
    "modelHelp": "Durumunu, yönlendirme koşullarını ve işlemlerini incelemek için modeli açın.",
    "routingCheck": "Yönlendirme koşulları",
    "routingUnknown": "Göreve özel uygunluğu incele",
    "capability": "Son yetenek kontrolü",
    "latency": "Yanıt süresi",
    "issue": "Mevcut sorun",
    "facts": "Kayıtlı ayrıntılar",
    "priority": "İlginizi bekliyor",
    "observed": "Son gözlem",
    "connection": "Bağlantı",
    "infrastructure": "Hizmet hazırlığı",
    "context": "Mevcut çalışma alanı",
    "navigation": "Çalışma alanı gezinmesi",
    "skip": "Çalışma alanına geç",
    "snapshot": "Durum kaydının kanıtı",
    "returnList": "Kişilere dön",
    "keepOpen": "Değişikliklerinizi tamamladıktan sonra kapatın.",
    "historyHelp": "Olayların özgün zamanları ve kayıtlı sonuçları korunur.",
    "health": "Sağlık",
    "availableActions": "Kullanılabilir işlemler",
    "noAutoClaim": "Son seçim, gerçek isteğe ve isteğin izinlerine de bağlıdır.",
    "checks": "Kontroller",
    "owner": "Korunan sahip",
    "minimize": "Ayrıntıyı daralt",
    "providerNotLoaded": "Sağlayıcı verisi doğrulanamadı.",
    "providerContext": "Bağlantı değişikliği mevcut passkey ve doğrulama kontrollerine tabidir.",
    "editHere": "Buradan değiştir",
    "accessOpen": "İzinli",
    "accessClosed": "Engelli",
    "accessConditional": "Koşullu",
    "permissionChange": "Bu yetkiyi değiştir",
    "permissionHelp": "Bu işlem kişinin doğrudan erişim kuralını değiştirir. Diğer kurallar erişimi sınırlayabilir; doğrulamadan sonra gerçek sonuç yenilenir.",
    "allowHere": "Erişime izin ver",
    "denyHere": "Erişimi engelle",
    "changeReason": "Bu değişikliği neden yapıyorsun?",
    "confirmPasskey": "Passkey ile doğrula ve uygula",
    "cancelChange": "Vazgeç",
    "roleHelp": "Roller yetkileri bir araya getirir. Atamadan sonra kişinin gerçekte kullanabildiği yetkileri bu kartta görebilirsin.",
    "addRoleHere": "Buradan rol ata",
    "chooseRole": "Rol seç",
    "roleOperator": "Platform işletimi",
    "roleMember": "Üye",
    "roleOwner": "Sahip",
    "roleAdmin": "Yönetici",
    "roleTeacher": "Öğretmen",
    "roleLearner": "Öğrenci",
    "capConsole": "Yapay zekâ asistanını kullanma",
    "capLid": "Öğrenme alanını kullanma",
    "permissionOther": "Uygulama yetkisi",
    "removeRoleHere": "Bu rolü kaldır",
    "roleSource": "Atanmış roller",
    "workingHere": "Doğrulanıyor ve güncelleniyor…",
    "modelSettings": "Kullanım ayarları",
    "modelCheck": "Bu modeli kontrol et",
    "modelFix": "Sorunu incele ve çöz",
    "modelNext": "Ne yapabilirim?",
    "modelHealthyHelp": "Bağlantı testi başarılı. Modelin hangi işlerde kullanılabildiğini kullanım ayarlarından görebilirsin.",
    "modelIssueHelp": "Bu modelin kontrol edilmesi gerekiyor. Nedeni ve uygulanabilecek işlemleri görmek için sorunu aç.",
    "modelStaleHelp": "Elimizdeki bilgi güncel değil. Test veya değişiklik yapmadan önce listeyi yenile.",
    "modelPendingHelp": "Modelin yanıt verip vermediğini kontrol edebilirsin. Testin geçmesi, modeli her iş için otomatik olarak açmaz.",
    "providerConnect": "Bağla",
    "providerConnectionHelp": "Kayıtlı bağlantı ayarları kullanılacak. Bağlantı, kullanılabilir olarak gösterilmeden önce doğrulanacak.",
    "providerMissingHelp": "Bu hizmet için bağlantı ayarları henüz kaydedilmemiş. Bağlamadan önce kurulumun tamamlanması gerekiyor.",
    "providerAddTitle": "Başka bir yapay zekâ hizmeti bağla",
    "providerAddHelp": "Bu ekrandan yeni hizmet ekleme henüz desteklenmiyor. Kurulmuş hizmetlerin bağlantılarını buradan yönetebilirsin.",
    "providerShowModels": "Modelleri burada aç",
    "lightTheme": "Açık tema",
    "darkTheme": "Koyu tema"
  },
  "de": {
    "overview": "Übersicht",
    "people": "Personen",
    "access": "Zugriff",
    "protection": "Schutz",
    "events": "Verlauf",
    "settings": "Einstellungen",
    "providers": "Anbieter",
    "models": "Modelle",
    "routing": "Routing",
    "more": "Mehr",
    "close": "Schließen",
    "back": "Zurück",
    "inspect": "Ansehen",
    "openDetail": "Details öffnen",
    "openDetailHelp": "Kontakt, Adressen, Zugriff und Aktivität im vollständigen Personendatensatz öffnen.",
    "refresh": "Aktualisieren",
    "searchPeople": "Person suchen",
    "all": "Alle Personen",
    "needsReview": "Prüfung erforderlich",
    "user": "Aktueller Benutzer",
    "language": "Sprache",
    "actions": "Aktionen",
    "help": "So funktioniert es",
    "technical": "Technische Details",
    "evidence": "Originalnachweise",
    "status": "Status",
    "why": "Grund",
    "impact": "Auswirkung",
    "verify": "Überprüfung",
    "role": "Organisationsrolle",
    "effective": "Wirksamer Zugriff",
    "static": "Statischer Zugriff",
    "passkeys": "Aktive Passkeys",
    "unlock": "Passkeys zum Entsperren",
    "trust": "Vertrauensgruppen",
    "keyReady": "Schlüsseleinrichtung bereit",
    "keyPending": "Schlüsseleinrichtung unvollständig",
    "keyWhy": "Laut Sicherheitsdatensatz ist der Schlüssel zum Verschlüsseln weiterer Schlüssel bereit.",
    "keyWhyMissing": "Im Sicherheitsdatensatz ist kein einsatzbereiter Schlüssel zum Verschlüsseln weiterer Schlüssel vermerkt.",
    "keyImpact": "Dies beschreibt nur die Schlüsseleinrichtung. Anmeldung und Berechtigungen werden separat geprüft.",
    "peopleHelp": "Finden Sie eine Person und prüfen Sie Zugriff und Details direkt hier.",
    "emptyPeople": "Keine Personen in dieser Ansicht",
    "emptyHelp": "Ändern Sie die Suche oder aktualisieren Sie die Datensätze.",
    "unknown": "Nicht verifiziert",
    "stale": "Die letzte Aktualisierung ist fehlgeschlagen. Angezeigte Daten können veraltet sein.",
    "loading": "Aktuelle Daten werden geladen…",
    "securityHelp": "Prüfen Sie, wo Handlungsbedarf besteht, und erledigen Sie den nächsten Schritt hier.",
    "controls": "Sicherheitsprüfungen",
    "summary": "Aktuelle Zusammenfassung",
    "noKnownIssues": "In diesen Prüfungen wurde kein Problem gemeldet",
    "unknownHealth": "Die Sicherheitsbewertung ist nicht verfügbar.",
    "score": "Gemeldeter Sicherheitswert",
    "reviewHere": "Hier prüfen",
    "register": "Registrierungen prüfen",
    "registerHelp": "Prüfen Sie ausstehende Registrierungen und vervollständigen Sie deren Zugriffseinrichtung.",
    "providerHelp": "Erkennen Sie verfügbare Dienste und klären Sie ihre Voraussetzungen direkt hier.",
    "readinessUnknown": "Routing-Bereitschaft nicht verifiziert",
    "readinessUnknownHelp": "Eine aktuelle Liste allein bestätigt keine ausführbare Route. Prüfen Sie die Routing-Regel.",
    "ready": "Bereit",
    "partial": "Teilweise bereit",
    "blocked": "Handlungsbedarf",
    "noModels": "Keine Modelle gemeldet",
    "modelHelp": "Öffnen Sie ein Modell, um Status, Routing-Voraussetzungen und Aktionen zu prüfen.",
    "routingCheck": "Routing-Voraussetzungen",
    "routingUnknown": "Aufgabenspezifische Eignung prüfen",
    "capability": "Letzte Fähigkeitsprüfung",
    "latency": "Antwortzeit",
    "issue": "Aktuelles Problem",
    "facts": "Erfasste Details",
    "priority": "Benötigt Ihre Aufmerksamkeit",
    "observed": "Letzte Beobachtung",
    "connection": "Verbindung",
    "infrastructure": "Dienstbereitschaft",
    "context": "Aktueller Arbeitsbereich",
    "navigation": "Arbeitsbereichsnavigation",
    "skip": "Zum Arbeitsbereich springen",
    "snapshot": "Nachweis des Statusdatensatzes",
    "returnList": "Zurück zu Personen",
    "keepOpen": "Schließen Sie die Ansicht, wenn Ihre Änderungen abgeschlossen sind.",
    "historyHelp": "Ereignisse behalten ihre ursprünglichen Zeitangaben und erfassten Ergebnisse.",
    "health": "Zustand",
    "availableActions": "Verfügbare Aktionen",
    "noAutoClaim": "Die endgültige Auswahl hängt auch von der konkreten Anfrage und ihren Berechtigungen ab.",
    "checks": "Prüfungen",
    "owner": "Geschützter Eigentümer",
    "minimize": "Details einklappen",
    "providerNotLoaded": "Anbieterdaten konnten nicht verifiziert werden.",
    "providerContext": "Für Verbindungsänderungen gelten die bestehenden Passkey- und Verifizierungsprüfungen.",
    "editHere": "Hier ändern",
    "accessOpen": "Erlaubt",
    "accessClosed": "Gesperrt",
    "accessConditional": "Bedingt",
    "permissionChange": "Diese Berechtigung ändern",
    "permissionHelp": "Diese Änderung betrifft die direkte Zugriffsregel. Weitere Regeln können den Zugriff einschränken; das Ergebnis wird nach der Bestätigung aktualisiert.",
    "allowHere": "Zugriff erlauben",
    "denyHere": "Zugriff sperren",
    "changeReason": "Warum änderst du dies?",
    "confirmPasskey": "Mit Passkey bestätigen und anwenden",
    "cancelChange": "Abbrechen",
    "roleHelp": "Rollen bündeln Berechtigungen. Prüfe nach der Zuweisung den wirksamen Zugriff in dieser Karte.",
    "addRoleHere": "Hier eine Rolle zuweisen",
    "chooseRole": "Rolle wählen",
    "roleOperator": "Plattformbetrieb",
    "roleMember": "Mitglied",
    "roleOwner": "Eigentümer",
    "roleAdmin": "Administrator",
    "roleTeacher": "Lehrkraft",
    "roleLearner": "Lernende",
    "capConsole": "KI-Assistenten verwenden",
    "capLid": "Lernbereich verwenden",
    "permissionOther": "Anwendungsberechtigung",
    "removeRoleHere": "Diese Rolle entfernen",
    "roleSource": "Zugewiesene Rollen",
    "workingHere": "Wird bestätigt und aktualisiert…",
    "modelSettings": "Nutzungseinstellungen",
    "modelCheck": "Dieses Modell prüfen",
    "modelFix": "Problem prüfen und beheben",
    "modelNext": "Was kann ich tun?",
    "modelHealthyHelp": "Der Verbindungstest war erfolgreich. In den Nutzungseinstellungen siehst du, welche Aufgaben dieses Modell verwenden können.",
    "modelIssueHelp": "Dieses Modell muss geprüft werden. Öffne das Problem, um Ursache und verfügbare Schritte zu sehen.",
    "modelStaleHelp": "Die Informationen sind nicht aktuell. Aktualisiere die Liste vor Tests oder Änderungen.",
    "modelPendingHelp": "Prüfe, ob das Modell antwortet. Ein erfolgreicher Test aktiviert es nicht automatisch für jede Aufgabe.",
    "providerConnect": "Verbinden",
    "providerConnectionHelp": "Die gespeicherten Verbindungseinstellungen werden verwendet. Die Verbindung wird geprüft, bevor sie als verfügbar erscheint.",
    "providerMissingHelp": "Für diesen Dienst sind noch keine Verbindungseinstellungen gespeichert. Vor dem Verbinden muss die Einrichtung abgeschlossen werden.",
    "providerAddTitle": "Weiteren KI-Dienst verbinden",
    "providerAddHelp": "Neue Dienste können hier noch nicht hinzugefügt werden. Bereits eingerichtete Verbindungen kannst du hier verwalten.",
    "providerShowModels": "Modelle hier anzeigen",
    "lightTheme": "Helles Design",
    "darkTheme": "Dunkles Design"
  }
} as const;
export type OsKey=keyof typeof osMessages.en;
export function useOsText(){const {locale}=useAppI18n();return (key:OsKey)=>osMessages[locale][key];}

function readTheme():"light"|"dark"{try{return localStorage.getItem("knsaix.appearance")==="dark"?"dark":"light";}catch{return "light";}}
if(typeof document!=="undefined")document.documentElement.dataset.osTheme=readTheme();
export function ThemeToggle(){
 const text=useOsText();const[theme,setTheme]=useState(readTheme);
 useEffect(()=>{const sync=(event:Event)=>{const value=(event as CustomEvent).detail;setTheme(value==="light"||value==="dark"?value:readTheme());};window.addEventListener("storage",sync);window.addEventListener("knsaix:appearance",sync);return()=>{window.removeEventListener("storage",sync);window.removeEventListener("knsaix:appearance",sync);};},[]);
 useEffect(()=>{document.documentElement.dataset.osTheme=theme;},[theme]);
 const toggle=()=>{const next=theme==="light"?"dark":"light";setTheme(next);document.documentElement.dataset.osTheme=next;try{localStorage.setItem("knsaix.appearance",next);}catch{}window.dispatchEvent(new CustomEvent("knsaix:appearance",{detail:next}));};
 return createElement("button",{type:"button",className:"os-theme-toggle",onClick:toggle,"aria-label":text(theme==="light"?"darkTheme":"lightTheme"),title:text(theme==="light"?"darkTheme":"lightTheme")},createElement("span",{"aria-hidden":true},theme==="light"?"☾":"☀"),createElement("span",null,text(theme==="light"?"darkTheme":"lightTheme")));
}
